export const count = 12;
export const width = 100 / count;
export const gutter = '8px';
export const gutterMobile = '8px';
